import { ReducerActionRotaSP } from 'store/modules/types';

import { ConsultarParametroLocalidadeDetalheRequest, Types } from './types';

export function consultarParametroLocalidadeDetalheRequest(
	token: string,
	data: ConsultarParametroLocalidadeDetalheRequest,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_PARAMETRO_LOCALIDADE_DETALHE,
		token,
		payload: {
			sigla: data.sigla,
			idOrgao: data.idOrgao,
		},
	};
}
export function consultarParametroLocalidadeDetalheSuccess(
	payload: object,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_PARAMETRO_LOCALIDADE_DETALHE_SUCCESS,
		payload,
	};
}
export function consultarParametroLocalidadeDetalheFailure(): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_PARAMETRO_LOCALIDADE_DETALHE_FAILURE,
		payload: null,
	};
}
export function consultarParametroLocalidadeDetalheClear(): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_PARAMETRO_LOCALIDADE_DETALHE_CLEAR,
		payload: null,
	};
}
